export enum GuildType {
  PvE = 'PVE',
  PvP = 'PVP'
}
